import strftime from '../vendor/strftime';

export const DATE_FORMAT = '%d %b %Y';
export const DATE_LONG_MONTH_FORMAT = '%d %B %Y';
export const FULL_DATE_FORMAT = '%a, %d %b %Y';
export const ISO_FORMAT = '%Y-%m-%d';
export const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec' ];
export const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export function formatDate(date) {
  if (!date) return null;

  return strftime(DATE_FORMAT, date);
}

export function formatDateLongMonth(date) {
  return strftime(DATE_LONG_MONTH_FORMAT, date);
}

export function formatFullDate(date) {
  if (!date) return null;

  return strftime(FULL_DATE_FORMAT, date);
}

export function isoDate(date) {
  if (!date) return null;

  return strftime(ISO_FORMAT, date);
}
